__webpack_require__.p = "/pokeApi/";